import { HeadingComponentConfig } from '@rappider/rappider-components/utils';
import { defaultToolbarTitleHeadingSize } from '@rappider/shared/definitions';

/**
 * Project information section title configuration
 */
export const projectInformationTitle: HeadingComponentConfig = {
  content: 'Project Information',
  type: defaultToolbarTitleHeadingSize
};

/**
 * Breadcrumb navigation for project information section
 */
export const projectInformationOptiontitle = [
  {
    label: 'Project',
    redirectUrl: '/projects'
  },
  {
    label: 'Project Information'
  }
];
